<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="ok"
  >
    <v-card>
      <v-icon color="primary" style="float: left; font-size: 4rem; padding:10px" size="x-large">mdi-bullhorn-outline</v-icon>
      <br/>
      <v-card-title>{{ title }}</v-card-title>
      <div style="padding: 20px;" v-html="message"></div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="singleButton" @click.stop="ok" color="primary">Verstanden</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "InfoDlg",
  props:{
    title: String,
    dialog: Boolean,
    message: String
  },
  data() {
    return {
      options: {
        width: 1200,
        zIndex: 200,
      }
    };
  },

  methods: {
    ok(){
      this.$emit('close');
    }
  }
};
</script>